export default "__VITE_ASSET__DjnT4lic__"